export default __webpack_public_path__ + "static/media/ai_color_tracking.19f1c4af.svg";